import { render } from "./DocumentHistory.vue?vue&type=template&id=03fc3220&scoped=true&ts=true"
import script from "./DocumentHistory.vue?vue&type=script&lang=ts"
export * from "./DocumentHistory.vue?vue&type=script&lang=ts"

import "./DocumentHistory.vue?vue&type=style&index=0&id=03fc3220&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fc3220"]])

export default __exports__